import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import Firebase from '../../../Firebase';
import { FaAlignRight } from 'react-icons/fa';
import './Header.scss';
import { property } from 'lodash';

function Header(props) {
  const [state, setState] = useState({
    toggle: false,
  });

  const Toggle = () => {
    setState({ toggle: !state.toggle });
  };

  const onLogout = () => {
    window.location.replace(process.env.PUBLIC_URL + '/');
  };
  const logout = () => {
    Firebase.logout(onLogout);
  };

  return (
    <div className='navBar '>
      <div className='limit-width'>
        <button onClick={Toggle}>
          <FaAlignRight />
        </button>
        <ul className={state.toggle ? 'nav-links show-nav' : 'nav-links'}>
          <li>
            <a href={process.env.PUBLIC_URL + '/'}>Home</a>
          </li>
          <li>
            <a href={process.env.PUBLIC_URL + '/#why-write'}> Why Write?</a>
          </li>
          <li>
            <a href={process.env.PUBLIC_URL + '/#about-us'}>About Us</a>
          </li>
          <li>
            <a href='https://stoichuman.com/' target='_blank'>
              Blog
            </a>
          </li>
          {Firebase.isLoggedIn() ? (
            <li>
              <Button className='pull-left' basic onClick={() => window.location.replace(process.env.PUBLIC_URL + '/write')}>
                Write
              </Button>
            </li>
          ) : (
            <li>
              <Button className='pull-left' basic onClick={() => window.location.replace(process.env.PUBLIC_URL + '/login')}>
                Login
              </Button>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}

export default withRouter(Header);
